import React from 'react';
import iconVerified from './iconVerified.png';
import css from './IconVerifiedBadge.module.scss';

const IconVerifiedBadge = props => {
  const { className, metadata } = props;
  if (!metadata?.verified) return null;
  const classes = className ? `${css.iconVerified} ${className}` : css.iconVerified;
  return <img className={classes} src={iconVerified} />;
};
export default IconVerifiedBadge;
